module.exports = __webpack_public_path__ + "img/collabs-banner.b246c9bd.jpg";